import { makeStyles } from '@mui/styles';

const Style = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}));

export default Style;
